<ul class="flex flex-row">
    @for (route of routes; track route) {
        @if (!route.hideFromNav) {
            <li
                class="flex justify-center items-start whitespace-nowrap"
                [routerLink]="route.fullRoute"
                routerLinkActive="active-link"
                #rla="routerLinkActive">
                <a class="font-semibold px-3 md:px-4">
                    @if (route.icon) {
                        <i class="{{ route.icon }} pr-1"></i>
                    }
                    @if (!rla.isActive) {
                        <span>{{ route.label }}</span>
                    }
                    @if (rla.isActive) {
                        <span class="active-label">{{ route.label }}</span>
                    }
                </a>
            </li>
        }
    }
</ul>
